export const PhoneIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.83331 3.54616C4.44162 2.66196 5.65718 2.91912 6.22158 3.83205L7.01907 5.12203C7.25547 5.50441 7.1981 5.9994 6.88052 6.3174L6.56709 6.63125C6.18913 7.00971 6.18913 7.62333 6.56709 8.00179L9.81781 11.2568C10.1958 11.6353 10.8086 11.6353 11.1865 11.2568L11.493 10.95C11.8138 10.6288 12.3143 10.5738 12.697 10.8176L14.1862 11.7665C15.0829 12.3379 15.331 13.5439 14.4586 14.1517C12.9147 15.2274 10.0695 15.9631 6.05382 11.9421C2.05538 7.93835 2.76667 5.09655 3.83331 3.54616Z"
        stroke="#05796B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
